.container {
  font-family: 'Onest', sans-serif;
  font-size: 16px;
  color: #505050;
  line-height: 1.5;
  margin: 0;
  padding: 0;

  /* Layout */
  width: 90%;
  max-width: 1300px;
  margin-left: auto;
  margin-right: auto;
}

.aboutSection {
  padding: 32px 0;
  text-align: center;
}

.title {
  font-size: 2rem;
  font-weight: 400;
  margin-bottom: 8px;
  color: #505050;
}

.intro {
  font-size: 1.1rem;
  color: #505050;
  margin-bottom: 32px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  font-weight: 200;
}

/* 4. Team Grid */
.teamGrid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 32px;
}

/* 5. Individual Founder Card */
.founderCard {
  flex: 1;
  max-width: 270px;
  background-color: #fffdf7;
  padding: 25px;
  border: 1px solid #e0e0e0;
  border-radius: 24px;
  corner-shape: superellipse(1.18);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  text-align: center;
}

.founderImage {
  width: 220px;
  height: 220px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 16px;
}

.founderName {
  font-size: 1.3rem;
  font-weight: 400;
  margin-bottom: 0;
  color: #505050;
}

.founderRole {
  font-size: 1rem;
  font-weight: 400;
  color: #505050;
}

.founderDetails {
  font-size: 1rem;
  line-height: 1.7;
  letter-spacing: 0.4;
  font-weight: 350;
  color: #505050;
}

@media (max-width: 768px) {
  .teamGrid {
    flex-direction: column;
    align-items: center;
  }

  .founderCard {
    max-width: 450px;
  }
}

@media (max-width: 480px) {
  .founderCard {
    max-width: 100%;
  }
}
